import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import * as _ from 'underscore';

@Component({
  selector: 'app-attrtion-tab',
  templateUrl: './attrtion-tab.component.html',
  styleUrls: ['./attrtion-tab.component.scss']
})
export class AttrtionTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightservive: CompanyInsightsService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService) { }
  companyDetails: any;
  currentCompanyName: any;
  functionStartIndex: number = 0;
  functions: any = [];
  functionsData: any = [];
  totalFunctionResultCount: number = 0;
  displayedColumns: string[] = ['key', 'attrition', 'hirecount'];
  @ViewChild('attritionTbSort') attritionTbSort: MatSort;
  totalAttritionCount: any = 0;
  top_next_employers_by_role: any;
  isViewMore: string = 'View More';
  recentAttritionAll: any[] = [];
  recentAttrition: any = [];
  recentAttritionStartIndex: number = 0;
  isViewMoreRecentAttrition: boolean = true;
  alternatecompanyNames: any[] = [];
  recentHiresDataAll: any[] = [];
  recentHiresData: any = [];
  attritionsubscription: Subscription;

  /** start index in function page */
  startFunction: number = 0;
  /**End index in function page */
  endFunction: number = 5;
  /**Number of items on each of function page */
  pageSizeFunction:number = 5;
  /**Current page number in function */
  currentPageFunction: number = 1;
  /**Total items in function page*/
  totalCountFunction = 0;
  aggregatescount: number = 50;

  /** start index in function page */
  startAttrtion: number = 0;
  /**Number of items on each of function page */
  pageSizeAttrtion:number = 6;
  /**Current page number in function */
  currentPageAttrtion: number = 1;
  /**Total items in function page*/
  totalCountAttrtion = 0;
  attrtionCount = 6;

  /**start index of recent hire for pagination */
  recentHireStartIndex: number = 0;
  /**Current page of recent hire */
  recentHireCurrentPage: number = 1;
  /**Page size of recent hire */
  recentHirePageSize: number = 6;
  recentHireAggCount = 6;
  /**Duration of recent hires in months */
  selectedMonth: any = '3';
  /**Total number of recent hires */
  totalRecentHiresCount: number = 0;
  attritionSortArr: any = [];
  

  attritionemptystate: Boolean = false;
  functionsname: any
  totalresultcount: any;
  attritiondataAI: any;
  /** Subscription var */
  subscriptions: Array<Subscription> = [];

  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    // this.attritionsubscription = this.personSearchService.companyDetail.subscribe((response) => {
    //   this.companyDetails = response;
    //   this.recentAttrition = [];
    //   this.recentHiresData = [];
    //   this.currentCompanyName = this.companyDetails.name;
    //   this.alternatecompanyNames = this.companyDetails.alternative_names && this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
    //   this.top_next_employers_by_role = this.companyDetails.top_next_employers_by_role;
    //   this.totalAttritionCount = this.top_next_employers_by_role && this.top_next_employers_by_role.all ? Object.values(this.top_next_employers_by_role.all).reduce((a: number, b: number) => a + b, 0) : 0;
      
      this.startFunction = 0;
      this.endFunction = 5;
      this.currentPageAttrtion = 1;

      this.startAttrtion = 0;
      this.currentPageFunction = 1;

      this.recentHireStartIndex = 0;
      this.recentHireCurrentPage = 1;

    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightservive.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightservive.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }  

  fetchPageData() {
    this.getFunction();
    this.getRecentAttrition();
    this.getRecentHires();
  }

  filterselected(event) {
    this.selectedMonth = event.target.value;
    this.recentHireStartIndex = 0;
    this.recentHireAggCount = 6;
    this.recentHireCurrentPage = 1;
    this.recentHiresData = [];
    this.getRecentHires();
  }

  getRecentHires() {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject : AggregationRequest = this.aggService.getRequestWithFilters();
    requestObject.companies = this.alternatecompanyNames;
    requestObject.durationinmonths = parseInt(this.selectedMonth);
    requestObject.resultsize = 50; // this.recentHireAggCount;
    requestObject.startindex = this.recentHireStartIndex;
    this.personSearchService.getRecentHires(requestObject).subscribe((response) => {
      this.recentHiresDataAll = response.data;
      this.recentHiresData = (this.recentHiresDataAll || []).slice(0, 6);
      this.totalRecentHiresCount = response.totalresultscount || 0;
    });
  }

  getRecentAttrition() {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject : AggregationRequest = this.aggService.getRequestWithFilters();
    requestObject.companies = this.alternatecompanyNames;
    requestObject.resultsize = 50; // this.attrtionCount;
    requestObject.startindex = this.startAttrtion;
    this.personSearchService.getRecentAttritionData(requestObject).subscribe((response) => {
      this.recentAttritionAll = response.data;
      this.recentAttrition = (this.recentAttritionAll || []).slice(0, 6);
      this.totalCountAttrtion = response.totalresultscount || 0;
    });
  }

  getFunction() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "function";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightservive.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.function;
      

      this.totalCountFunction = tempData.length;

      this.functionsData = tempData.map((element) => {
        const count: any = this.top_next_employers_by_role && this.top_next_employers_by_role[element.key] ? Object.values(this.top_next_employers_by_role[element.key]).reduce((a: number, b: number) => a + b, 0) : 0;
        return { ...element, key: this.cleanCompanyName(element.key), attritionPercentage: this.totalAttritionCount ? ((count / this.totalAttritionCount) * 100).toFixed(2) : 0 }
      });
      this.attritionSortArr = this.functionsData;
      this.functionsData = this.functionsData.slice(this.startFunction, this.endFunction);

      this.functionsname = _.pluck(this.attritionSortArr, 'key')
      this.functions = new MatTableDataSource(this.functionsData);
      this.functions.sort = this.attritionTbSort;

      this.manualSort();
      this.getattrition();
      this.getrecenthires();
     
      this.attritionemptystate = true;
    });
  }

  manualSort(){
    this.reSortArr(this.attritionTbSort);
  }

  reSortArr(sort){
    const tempData = this.attritionSortArr;

    if (!sort || !sort.active || sort.direction === '') {
      this.functionsData = tempData.slice(this.startFunction, this.endFunction);
      this.functions = new MatTableDataSource(this.functionsData);
      this.functions.sort = this.attritionTbSort;
      return;
    }
     
    this.attritionSortArr = tempData.sort((a,b)=>{
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'hirecount': return this.compare(a.hirecount, b.hirecount, isAsc);
        case 'attrition': return this.compare(a.attrition, b.attrition, isAsc);
        default: return 0;
      }
    })
    this.functionsData = this.attritionSortArr.slice(this.startFunction, this.endFunction);
    this.functions = new MatTableDataSource(this.functionsData);
    this.functions.sort = this.attritionTbSort;
  }

  compare(a:number, b:number, isAsc:boolean){
    return(a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

/**
* Function set the start and end of aggreggate data according to page number in title container
* @param index page number in pagination
*/
setPageFunction(index: number) {
  this.startFunction = (index - 1) * this.pageSizeFunction;
  this.endFunction = this.startFunction + this.pageSizeFunction;
  this.currentPageFunction = index;
  if (this.aggregatescount / this.pageSizeFunction <= index){
    this.aggregatescount = this.aggregatescount + this.pageSizeFunction;
    this.getFunction();
  }
  this.manualSort();
}

/**
* Funtion set the start and end of attrition data according to page number in title container
* @param index page number in pagination
*/
setPageAttrtion(index: number) {
  this.startAttrtion = (index - 1) * this.pageSizeAttrtion;
  this.currentPageAttrtion = index;
  this.getRecentAttrition();
}

  /**
   * Function set the start and end of recent hire data according to page number
   * @param index page number in pagination
   */
  setPageRecentHire(index: number){
    this.recentHireStartIndex = (index - 1) * this.recentHirePageSize;
    this.recentHireCurrentPage = index;
    this.getRecentHires();
  }
    
  getEmployeePercentage(value) {
    return ((value / this.totalFunctionResultCount) * 100).toFixed(2);
  }

  private cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getattrition() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "pastfunction";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightservive.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations.pastfunction;
      this.totalresultcount = response.data.totalresultscount
      this.attritionSortArr.map(res=>{
        const pastfunction = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.attrition = pastfunction && pastfunction.doc_count ? this.getattritionpercentage(pastfunction.doc_count): '0';
        return res;
      })
      this.getattritionai(this.attritionSortArr);
    })
  }

  getattritionpercentage(value) {
    return ((value / this.totalFunctionResultCount) * 100).toFixed(2);
  }

  getrecenthires() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightservive.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations.current_function;
      this.attritionSortArr.map(res=>{
        const hires = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.hirecount = hires && hires.doc_count ? this.getEmployeePercentage(hires.doc_count): '0';
        return res;
      })
      this.getattritionai(this.attritionSortArr);
    })
  }

  getattritionai(data) {
    let attritiondata:any;
    attritiondata = data.map(x=>{
      let res: any ={};
      res['Role'] = x.key;
      res['Attrition (%)'] = x.attrition+'%';
      res['Hiring (%)'] = x.hirecount+'%';
      return res;
    })
  
  this.attritiondataAI = {
    attrition: attritiondata
  }
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'attrition') return;

    const payloadForInsightsExport: ExportPayload = {
      tab: 'attritionandhiring',
      companydetails: this.companyDetails,
      totalresultcount: this.totalresultcount,
      attrition: this.attritionSortArr,
      recentAttrition: this.recentAttritionAll,
      recentHires: this.recentHiresDataAll,
      totalRecentHiresCount: this.totalRecentHiresCount
    }
    this.companyinsightservive.sendInsightsExportData(payloadForInsightsExport);
  }
}
